import * as Tokens from './tokens.js';

export default Tokens;
